import { SDK } from "@sdk";

import { iFBCallLog } from "@sdk/fb-call-logs/fb-call-logs-model";
import { Store } from "redux";
import { QueryConfig } from "store/utils/query-config";
import { iStore } from "../../store.model";
import { CreateHelpersForEntity } from "../../utils/entity-slice-creator";
import { FBCallLogsDefaultQueryConfig } from "./fb-call-logs-default-query";
import { FBCallLogsSlice } from "./fb-call-logs.slice";

export const loadAllFBCallLogs =
  () => async (store: Store<iStore>, forceReload?: boolean) => {
    await loadFBCallLogsQuery(FBCallLogsDefaultQueryConfig, "all")(
      store,
      forceReload,
    );
  };

export const generateFBCallLogOfContactQuery = (contactId: string) => ({
  ...FBCallLogsDefaultQueryConfig,
  query: {
    contactId,
  },
});

export const generateFBCallLogOfRingAgentQuery = (ringAgentId: string) => ({
  ...FBCallLogsDefaultQueryConfig,
  query: {
    ringAgents: ringAgentId,
  },
});

export const loadFBCallLogOfContact =
  (contactId: string) =>
  async (store: Store<iStore>, forceReload?: boolean) => {
    await loadFBCallLogsQuery(
      generateFBCallLogOfContactQuery(contactId),
      JSON.stringify(generateFBCallLogOfContactQuery(contactId)),
    )(store, forceReload);
  };

export const loadFBCallLogOfRingAgent =
  (ringAgentId: string) =>
  async (store: Store<iStore>, forceReload?: boolean) => {
    await loadFBCallLogsQuery(
      generateFBCallLogOfRingAgentQuery(ringAgentId),
      JSON.stringify(generateFBCallLogOfRingAgentQuery(ringAgentId)),
    )(store, forceReload);
  };

export const loadQueryFBCallLogs =
  (queryConfig: QueryConfig, queryAlias?: string) =>
  async (store: Store<iStore>, forceReload?: boolean) => {
    queryAlias = queryAlias || JSON.stringify(queryConfig);
    await loadFBCallLogsQuery(queryConfig, queryAlias)(store, forceReload);
  };

export const {
  loadEntityQueries: loadFBCallLogsQuery,
  loadEntityById: loadFBCallLogById,
  loadMoreEntityQueries: loadMoreFBCallLogsQueries,
} = CreateHelpersForEntity<iStore, iFBCallLog>({
  sliceName: "FBCallLogs",
  slice: FBCallLogsSlice,
  isPaginatedQueries: true,
  fetchPageSize: 50,
  loadEntityQueryProvider: (query) => SDK.FBCallLogs.query(query),
  loadEntityByIdProvider: (entityId: string) =>
    SDK.FBCallLogs.getById(entityId),
});
